export const featureRequestTemplates = {
  en: `
New Feature

Is your feature request related to a problem?
A clear and concise description of what the problem is. Ex. I'm always frustrated when [...]
Please describe...

----------------------------------------------
Describe the solution you'd like
A clear and concise description of what you want to happen.
Please describe...

----------------------------------------------
Describe alternatives you've considered
A clear and concise description of any alternative solutions or features you've considered.
Please describe...

----------------------------------------------
Use cases and impact
Examples of how the feature would be beneficial and an estimation of how much impact it would have.
Please describe...

----------------------------------------------
Additional context
Add any other context or screenshots about the feature request here.
Please describe...

----------------------------------------------
Contact Information
Title: 
Last Name:
First Name:
Position:
Organization:
Email:
Phone Number (for any questions):
`,

  de: `
Neue Funktion

Bezieht sich Ihre Feature-Anfrage auf ein Problem?
Eine klare und präzise Beschreibung des Problems. Z.B. Es frustriert mich immer, wenn [...]
Bitte beschreiben Sie...

----------------------------------------------
Beschreiben Sie die gewünschte Lösung
Eine klare und präzise Beschreibung dessen, was passieren soll.
Bitte beschreiben Sie...

----------------------------------------------
Beschreiben Sie Alternativen, die Sie in Betracht gezogen haben
Eine klare und präzise Beschreibung aller alternativen Lösungen oder Funktionen, die Sie in Betracht gezogen haben.
Bitte beschreiben Sie...

----------------------------------------------
Anwendungsfälle und Auswirkungen
Beispiele dafür, wie die Funktion nützlich wäre und eine Einschätzung der Auswirkungen.
Bitte beschreiben Sie...

----------------------------------------------
Zusätzlicher Kontext
Fügen Sie hier weitere Kontextinformationen oder Screenshots zur Feature-Anfrage hinzu.
Bitte beschreiben Sie...

----------------------------------------------
Kontakt Information
Anrede:
Name:
Vorname:
Funktion:
Organisation:
Mail:
Telefonnummer (für Rückfragen):
`,

  fr: `
Nouvelle fonctionnalité

Votre demande de fonctionnalité est-elle liée à un problème ?
Une description claire et concise du problème. Ex. Je suis toujours frustré quand [...]
Veuillez décrire...

----------------------------------------------
Décrivez la solution que vous souhaitez
Une description claire et concise de ce que vous voulez qu'il se passe.
Veuillez décrire...

----------------------------------------------
Décrivez les alternatives que vous avez envisagées
Une description claire et concise des solutions ou fonctionnalités alternatives que vous avez envisagées.
Veuillez décrire...

----------------------------------------------
Cas d'utilisation et impact
Exemples de l'utilité de la fonctionnalité et estimation de son impact.
Veuillez décrire...

----------------------------------------------
Contexte supplémentaire
Ajoutez ici tout autre contexte ou captures d'écran concernant la demande de fonctionnalité.
Veuillez décrire...

----------------------------------------------
Informations de contact
Civilité:
Nom:
Prénom:
Fonction:
Organisation:
E-mail:
Numéro de téléphone (pour d'éventuelles questions):
`,

  it: `
Nuova funzionalità

La sua richiesta di funzionalità è legata a un problema?
Una descrizione chiara e concisa del problema. Es. Sono sempre frustrato quando [...]
Si prega di descrivere...

----------------------------------
Descriva la soluzione che vorrebbe
Una descrizione chiara e concisa di ciò che vuole che accada.
Si prega di descrivere...

----------------------------------------------
Descriva le alternative considerate
Una descrizione chiara e concisa di eventuali soluzioni o funzionalità alternative che ha considerato.
Si prega di descrivere...

----------------------------------------------
Casi d'uso e impatto
Esempi di come la funzionalità sarebbe utile e una stima del suo impatto.
Si prega di descrivere...

----------------------------------------------
Contesto aggiuntivo
Aggiunga qui qualsiasi altro contesto o screenshot sulla richiesta di funzionalità.
Si prega di descrivere...

----------------------------------------------
Informazioni di contatto
Titolo:
Cognome:
Nome:
Ruolo:
Organizzazione:
E-mail:
Numero di telefono (per eventuali domande):
`,
};
